import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { GMCContext } from "./GMCContext";


function QrCodeAuth() {
  const { setToken } = useContext(GMCContext);
  const [authNumber, setAuthNumber] = useState("");
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [msg, setMsg] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();


  const insertCode = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "verify",
        submethod: "insert",
        key: process.env.REACT_APP_KEY,
        authNumber: authNumber,
        address: state.address,
        _id: state._id,
      });
      // console.log('response', response)
      const { resCode, error, token } = response.data;

      if (resCode === 200) {
        if (token) {
          // console.log('token', token)
          setMsg("Verified Successfully");
          setShowMsg(true);
          localStorage.setItem("mark#321", token);
          localStorage.setItem("mark#0143", JSON.stringify({ username: state.username, id: state._id }));
          setToken(token);
          navigate("/dashbord");
        } else {
          setErrorMessage("Unable To Generate Token.");
          setError(true);
        }
      } else {
        setErrorMessage(error || "Verification Failed. Please Try Again.");
        setError(true);
      }
    } catch (err) {
      console.error("Error Inserting Data:", err);
      setErrorMessage("Network Error. Please Try Again Later.");
      setError(true);
    }
  };


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission if inside a form
      insertCode();
    }
  };

  return (
    <div className="auth-page-content vh-100">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6 col-lg-6 col-xl-5">
            <div className="card mt-4 card-bg-fill">
              <div className="card-body p-4">
                <div className="mb-4">
                  <div className="avatar-lg mx-auto">
                    <div className="avatar-title bg-light text-primary display-5 rounded-circle">
                      <i className=" ri-key-2-line" />
                    </div>
                  </div>
                </div>
                <div className="p-2 mt-4">
                  <div className="text-muted text-center mb-4 mx-lg-3">
                    <h4>Verify Your Authentication Key!</h4>
                  </div>
                  <form autoComplete="off">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-lg bg-light border-light text-center"
                        onChange={(e) => setAuthNumber(e.target.value)}
                        onKeyDown={handleKeyDown} // Add this line
                      />
                    </div>
                  </form>
                  {error && errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}
                  {showMsg && msg && (
                    <div className="alert alert-success" role="alert">
                      {msg}
                    </div>
                  )}
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-success w-100"
                      onClick={insertCode}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
              {/* end card body */}
            </div>
            {/* end card */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrCodeAuth;
